import {
  Button,
  ControlGroup,
  Elevation,
  InputGroup,
  NumericInput,
  Spinner,
  Tag,
  Card,
} from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import React from "react";
import { apiCallPost, niceDate } from "../fns/util";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import { nanoid } from "nanoid";

class LedgerCreator extends React.Component {
  state = {
    /**TYPE */
    type: null,
    changed: false,
    /** ITEM SEARCH */
    searchingItems: false,
    itemSearchResults: [],
    searchItem: null,
    /** CURRENTLY CHOSEN */
    isLoadingItemInventory: false,
    currentlyChosenItemInventory: [],
    currentlyChosenItemSerialNumber: null,
    currentlyChosenItemEnteredQty: 0,
    currentlyChosenItemEnteredSubQty: 0,
    /**RECEIVING SEARCH */
    searchingReceiving: false,
    receivingSearchResults: [],
    receivingLocationItem: null,
    /** ITEMS */
    items: [],
    /** REMOVE */
    reasonRemoval: null,
    removalNotes: "",
    /** USE */
    isSurgery: false,
    isSale: false,
    relatedSxId: null,
    relatedOrderId: null,
    relatedPatientName: null,
    relatedPatientId: null,
    relatedPatientGenericID: null,
    useNotes: "",
    /**SHIPMENT */
    trackingDetails: "",
    isReceived: false,
    toReceivingLocation: null,
    searchingToReceiving: false,
    toReceivingSearchResults: [],
    toReceivingLocationItem: null,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      if (apiUrl === "item") {
        payload["showWhich"] = "CURRENT";
      }
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/${apiUrl}/search`,
        payload
      );
      let results = res;
      results = _.filter(results, (x) => !x.isShell);
      results = _.filter(results, (x) => !x.isItemGeneratorMother);
      results = _.filter(results, (x) => !x.isItemService);
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderChooseReceivingLocation = () => {
    if (!this.state.type) {
      return null;
    }
    return (
      <ControlGroup>
        <Tag minimal large>
          Location
        </Tag>
        {this.state.recvLocation && this.state.recvLocation.entityName ? (
          <ControlGroup>
            <Tag minimal large intent="primary">
              {this.state.recvLocation.entityName}
            </Tag>
            <Tag minimal large>
              {this.state.location}
            </Tag>
            <Button
              icon="edit"
              onClick={() =>
                this.setState({
                  recvLocation: null,
                })
              }
            />
          </ControlGroup>
        ) : (
          <AsyncSelWrap
            showSelectProp={true}
            placeholder="Receiving Locations..."
            searching={this.state.searchingReceiving}
            items={this.state.receivingSearchResults.map((each) => {
              return {
                ...each,
                item: each.entityName,
                entityTypeString: each.branchName,
                helper: each.branchStoreName,
              };
            })}
            selectedItem={
              this.state.receivingLocationItem
                ? {
                    ...this.state.receivingLocationItem,
                    item: this.state.receivingLocationItem.entityName,
                  }
                : null
            }
            update={(item) =>
              this.search(
                item,
                "receivingSearchResults",
                "searchingReceiving",
                "receivingLocationItem",
                "recvLocations"
              )
            }
            onChange={(item) => {
              this.setState({
                receivingLocationItem: item,
                recvLocation: item,
                location: item.branchName,
              });
            }}
          />
        )}
      </ControlGroup>
    );
  };
  renderChooseType = () => {
    return (
      <ControlGroup>
        <Tag minimal large>
          Choose Type of Ledger Action
        </Tag>
        <SingleSelectWrapper
          selectedItem={this.state.type}
          showSelectProp={true}
          items={["SHIPMENT", "USE", "REMOVE"]}
          onChange={(item) =>
            this.setState({
              type: item,
              receivingLocationItem: null,
              receivingSearchResults: [],
              searchingReceiving: false,
              recvLocation: null,
              location: null,
              items: [],
            })
          }
        />
      </ControlGroup>
    );
  };
  renderAddItemTopBar = () => {
    if (!this.state.type) {
      return null;
    }
    if (!this.state.recvLocation) {
      return null;
    }
    return (
      <ControlGroup>
        <Tag minimal large icon="search">
          Search and Add Items
        </Tag>
        <AsyncSelWrap
          showSelectProp={true}
          placeholder="Items..."
          searching={this.state.searchingItems}
          items={this.state.itemSearchResults.map((each) => {
            return {
              ...each,
              item: each.entityName,
              helper: _.startCase(_.lowerCase(each.category)),
              entityTypeString: each.itemNameSuffix,
            };
          })}
          selectedItem={
            this.state.searchItem
              ? {
                  ...this.state.searchItem,
                  item: this.state.searchItem.itemNameSuffix
                    ? `${this.state.searchItem.entityName} - ${this.state.searchItem.itemNameSuffix}`
                    : this.state.searchItem.entityName,
                }
              : null
          }
          update={(item) =>
            this.search(
              item,
              "itemSearchResults",
              "searchingItems",
              "searchItem",
              "item"
            )
          }
          onChange={async (item) => {
            let id = item._id;
            let idx = _.findIndex(this.state.items, (x) => x.priceId === id);
            if (idx > -1) {
              cogoToast.error("You have already added this item.");
              return;
            }
            try {
              this.setState({ isLoadingItemInventory: true });
              let itemInventoryDetails = await apiCallPost(
                `/ims2/${this.props.authStore.prefix}/inventory/stock`,
                { itemId: item._id, location: this.state.location }
              );
              this.setState({
                currentlyChosenItemInventory: itemInventoryDetails,
                isLoadingItemInventory: false,
                searchItem: item,
              });
            } catch (err) {
              this.setState({ isLoadingItemInventory: false });
              cogoToast.error(
                "We ran into an error. Please contact support if this persists"
              );
            }
          }}
        />
        {this.state.isLoadingItemInventory ? <Spinner size={20} /> : null}
        {this.renderSNChooser()}
        {this.renderCurrentInventory()}
      </ControlGroup>
    );
  };
  renderSNChooser = () => {
    if (!this.state.searchItem) {
      return null;
    }
    if (
      this.state.currentlyChosenItemInventory &&
      this.state.currentlyChosenItemInventory.length
    ) {
      return (
        <ControlGroup>
          <Tag minimal large>
            Choose Serial Number
          </Tag>
          <SingleSelectWrapper
            showSelectProp={true}
            items={this.state.currentlyChosenItemInventory.map(
              (each) => each.serialNumber
            )}
            selectedItem={this.state.currentlyChosenItemSerialNumber}
            onChange={(item) => {
              this.setState({
                currentlyChosenItemSerialNumber: item,
                currentlyChosenItemEnteredQty: 0,
                currentlyChosenItemEnteredSubQty: 0,
              });
            }}
          />
        </ControlGroup>
      );
    } else {
      return (
        <Tag minimal large>
          No inventory found.
        </Tag>
      );
    }
  };
  renderCurrentInventory = () => {
    if (!this.state.currentlyChosenItemSerialNumber) {
      return null;
    }
    let item = _.find(
      this.state.currentlyChosenItemInventory,
      (x) => x.serialNumber === this.state.currentlyChosenItemSerialNumber
    );
    let expiryString = item.itemHasExpiry
      ? `Expires on ${niceDate(item.expiresOn)}`
      : "Does not expire";

    return (
      <ControlGroup>
        <Tag minimal large>
          {expiryString}
        </Tag>
        <Tag minimal large intent="primary">
          In Stock: {this.renderQuantityNice(item)}
        </Tag>
        {this.renderEnteredQty(item)}
      </ControlGroup>
    );
  };
  renderEnteredQty = (item) => {
    let currentQtyInteger = Math.floor(
      item.quantity / item.subunitOfConsumption
    );
    if (item.quantity < 1) {
      return (
        <Tag large minimal>
          Less than 1 quantity remaining. No action possible.
        </Tag>
      );
    }
    return (
      <ControlGroup>
        <NumericInput
          clampValueOnBlur
          min={0}
          max={currentQtyInteger}
          buttonPosition="NONE"
          style={{ width: "7em" }}
          rightElement={<Tag minimal>{item.itemUnitName}</Tag>}
          value={
            this.state.currentlyChosenItemEnteredQty / item.subunitOfConsumption
          }
          onValueChange={(num) => {
            this.setState({
              currentlyChosenItemEnteredQty: num * item.subunitOfConsumption,
            });
          }}
        />
        <NumericInput
          clampValueOnBlur
          min={0}
          max={item.subunitOfConsumption - 1}
          buttonPosition="NONE"
          style={{ width: "7em" }}
          rightElement={<Tag minimal>{item.itemSubunitName}</Tag>}
          value={this.state.currentlyChosenItemEnteredSubQty}
          onValueChange={(num) => {
            this.setState({
              currentlyChosenItemEnteredSubQty: num,
            });
          }}
        />
        {this.state.currentlyChosenItemEnteredQty +
          this.state.currentlyChosenItemEnteredSubQty >=
        1 ? (
          <Button
            icon="add"
            onClick={() => {
              // check if this itemId -- serialNumber is already added.
              let idx = _.findIndex(this.state.items, (x) => {
                console.log(
                  x,
                  x.serialNumber,
                  this.state.currentlyChosenItemSerialNumber,
                  x.itemId,
                  this.state.searchItem._id
                );
                return (
                  x.inventoryDetails.serialNumber ===
                    this.state.currentlyChosenItemSerialNumber &&
                  x.itemId === this.state.searchItem._id
                );
              });
              if (idx !== -1) {
                cogoToast.error("This item is already added to the list.");
                return;
              }
              let obj = {
                nanoid: nanoid(),
                itemId: this.state.searchItem._id,
                itemEntityName: this.state.searchItem.entityName,
                itemNameSuffix: this.state.searchItem.itemNameSuffix,
                itemName: this.state.searchItem.itemNameSuffix
                  ? `${this.state.searchItem.entityName} - ${this.state.searchItem.itemNameSuffix}`
                  : this.state.searchItem.entityName,
                itemTrackingType: this.state.searchItem.itemTrackingType,
                itemHasExpiry: this.state.searchItem.itemHasExpiry,
                itemUnitName: this.state.searchItem.itemUnitName,
                itemSubunitName: this.state.searchItem.itemSubunitName,
                itemCategory: this.state.searchItem.category,
                inventoryDetails: {
                  serialNumber: this.state.currentlyChosenItemSerialNumber,
                  quantity:
                    this.state.currentlyChosenItemEnteredQty +
                    this.state.currentlyChosenItemEnteredSubQty,
                  expiresOn: item.expiresOn,
                  subunitOfConsumption: item.subunitOfConsumption,
                },
              };
              this.setState({
                items: [...this.state.items, obj],
                currentlyChosenItemSerialNumber: null,
                currentlyChosenItemEnteredQty: 0,
                currentlyChosenItemEnteredSubQty: 0,
              });
            }}
          />
        ) : null}
      </ControlGroup>
    );
  };
  renderAddedItems = () => {
    if (!this.state.items.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No items added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.state.items.map((each) => {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag
            minimal
            large
            onRemove={() => {
              let list = this.state.items;
              let idx = _.findIndex(list, (x) => x.nanoid === each.nanoid);
              list.splice(idx, 1);
              this.setState({ items: list });
            }}
          >
            {each.itemName}
          </Tag>
          <Tag minimal large intent="success">
            {each.inventoryDetails.serialNumber}
          </Tag>
          <Tag minimal large intent="warning">
            {each.inventoryDetails.quantity /
              each.inventoryDetails.subunitOfConsumption}{" "}
            {each.itemUnitName}
          </Tag>
        </ControlGroup>
      );
    });
  };
  renderQuantityNice = (item) => {
    let qty = item.quantity;
    let sub = item.subunitOfConsumption;
    let unit = item.itemUnitName;
    let subunit = item.itemSubunitName;
    let integerQty = Math.floor(qty / sub);
    let fracQty = qty % sub;
    let str = `${integerQty} ${unit}`;
    if (fracQty) {
      str = str + ` + ${fracQty} ${subunit}`;
    }
    return str;
  };
  renderMetadataEntry = () => {
    if (!this.state.type) {
      return null;
    }
    if (this.state.type === "SHIPMENT") {
      return (
        <ControlGroup vertical>
          <ControlGroup>
            <Tag minimal large>
              Destination
            </Tag>
            <AsyncSelWrap
              showSelectProp={true}
              placeholder="Destination Locations..."
              searching={this.state.searchingToReceiving}
              items={this.state.toReceivingSearchResults.map((each) => {
                return {
                  ...each,
                  item: each.entityName,
                  entityTypeString: each.branchName,
                  helper: each.branchStoreName,
                };
              })}
              selectedItem={
                this.state.toReceivingLocationItem
                  ? {
                      ...this.state.toReceivingLocationItem,
                      item: this.state.toReceivingLocationItem.entityName,
                    }
                  : null
              }
              update={(item) =>
                this.search(
                  item,
                  "toReceivingSearchResults",
                  "searchingToReceiving",
                  "toReceivingLocationItem",
                  "recvLocations"
                )
              }
              onChange={(item) => {
                this.setState({
                  toReceivingLocationItem: item,
                });
              }}
            />
          </ControlGroup>
          <ControlGroup>
            <Tag minimal large>
              Tracking Details
            </Tag>
            <InputGroup
              value={this.state.trackingDetails}
              onChange={(event) =>
                this.setState({ trackingDetails: event.target.value })
              }
            />
          </ControlGroup>
        </ControlGroup>
      );
    }
    if (this.state.type === "USE") {
      return (
        <ControlGroup vertical>
          <ControlGroup>
            <Tag minimal large>
              Usage Notes
            </Tag>
            <InputGroup
              value={this.state.useNotes}
              onChange={(event) =>
                this.setState({ useNotes: event.target.value })
              }
            />
          </ControlGroup>
        </ControlGroup>
      );
    }
    if (this.state.type === "REMOVE") {
      return (
        <ControlGroup vertical>
          <ControlGroup>
            <Tag minimal large>
              Removal Reason
            </Tag>
            <SingleSelectWrapper
              items={[
                "Return to Vendor",
                "Damaged in Transit",
                "Damaged at Site",
                "Entered Incorrectly",
                "Scrap",
                "Other",
              ]}
              showSelectProp={true}
              selectedItem={this.state.reasonRemoval}
              onChange={(item) => this.setState({ reasonRemoval: item })}
            />
          </ControlGroup>
          <ControlGroup>
            <Tag minimal large>
              Removal Notes
            </Tag>
            <InputGroup
              value={this.state.removalNotes}
              onChange={(event) =>
                this.setState({ removalNotes: event.target.value })
              }
            />
          </ControlGroup>
        </ControlGroup>
      );
    }
  };
  renderSave = () => {
    let errors = [];
    if (!this.state.type) {
      errors.push("Please choose an activity type.");
    }
    if (!this.state.items.length) {
      errors.push("Please add items to the ledger.");
    }
    if (this.state.type === "SHIPMENT") {
      if (!this.state.toReceivingLocationItem) {
        errors.push("Please choose a receiving location.");
      }
      if (this.state.toReceivingLocationItem) {
        if (
          this.state.toReceivingLocationItem._id === this.state.recvLocation._id
        ) {
          errors.push("Cannot send to the same location.");
        }
      }
    }
    if (this.state.type === "USE") {
      if (!this.state.useNotes) {
        errors.push("Please add usage notes.");
      }
    }
    if (this.state.type === "REMOVE") {
      if (!this.state.reasonRemoval) {
        errors.push("Please choose a removal reason.");
      }
    }
    if (errors.length) {
      return errors.map((each) => {
        return (
          <ControlGroup>
            <Tag intent="danger" minimal icon="warning-sign" large>
              {each}
            </Tag>
          </ControlGroup>
        );
      });
    }
    return (
      <Button
        icon="endorsed"
        text="Save"
        fill
        intent="success"
        loading={this.state.creatingLedgerEntries}
        onClick={() => this.createLedgerEntries()}
      />
    );
  };
  createLedgerEntries = async () => {
    let items = this.state.items;
    let listOfItemIDs = items.map((each) => each.itemId);
    let uniqListOfItemIDs = _.uniq(listOfItemIDs);
    let whichApi = "";
    let itemPayloadArray = [];
    for (let i = 0; i < uniqListOfItemIDs.length; i++) {
      let obj = {};
      let eligibleItems = _.filter(
        items,
        (x) => x.itemId === uniqListOfItemIDs[i]
      );
      let sample = eligibleItems[0];
      obj["location"] = this.state.recvLocation.branchName;
      obj["itemId"] = uniqListOfItemIDs[i];
      obj["itemEntityName"] = sample.itemEntityName;
      obj["itemSubunitName"] = sample.itemSubunitName;
      obj["itemUnitName"] = sample.itemUnitName;
      obj["itemNameSuffix"] = sample.itemNameSuffix;
      obj["itemName"] = sample.itemName;
      obj["itemTrackingType"] = sample.itemTrackingType;
      obj["itemHasExpiry"] = sample.itemHasExpiry;
      obj["recvLocation"] = this.state.recvLocation;
      obj["itemCategory"] = sample.itemCategory;
      if (this.state.type === "SHIPMENT") {
        whichApi = "actionShipmentCreate";
        obj["metadata"] = {
          fromReceivingLocation: this.state.recvLocation,
          toReceivingLocation: this.state.toReceivingLocationItem,
          isReceived: this.state.isReceived,
          trackingDetails: this.state.trackingDetails,
        };
      } else if (this.state.type === "USE") {
        whichApi = "actionUse";
        obj["metadata"] = {
          isSurgery: this.state.isSurgery,
          isSale: this.state.isSale,
          isOptical: false,
          isPharmacy: false,
          relatedSxId: this.state.relatedSxId,
          relatedOrderId: this.state.relatedOrderId,
          relatedPatientName: this.state.relatedPatientName,
          relatedPatientId: this.state.relatedPatientId,
          notes: this.state.useNotes,
        };
      } else if (this.state.type === "REMOVE") {
        whichApi = "actionRemove";
        obj["metadata"] = {
          reasonRemoval: this.state.reasonRemoval,
          notes: this.state.removalNotes,
        };
      }
      obj["items"] = eligibleItems.map((each) => {
        return {
          serialNumber: each.inventoryDetails.serialNumber,
          quantity: each.inventoryDetails.quantity,
          expiresOn: each.inventoryDetails.expiresOn,
          subunitOfConsumption: each.inventoryDetails.subunitOfConsumption,
        };
      });
      itemPayloadArray.push(obj);
    }

    try {
      cogoToast.loading("Creating ledger entries...");
      this.setState({ creatingLedgerEntries: true });

      await Promise.all(
        itemPayloadArray.map((y) =>
          apiCallPost(
            `/ims2/${this.props.authStore.prefix}/ledger/${whichApi}`,
            y
          )
        )
      );
      this.props.onCreate();
      cogoToast.success("Ledger entries created.");
      this.setState({ creatingLedgerEntries: false });
    } catch (err) {
      this.setState({ creatingLedgerEntries: false });
      cogoToast.error("We ran into an error creating ledger entries.");
    }
  };
  renderAll = () => {
    return (
      <ControlGroup vertical>
        {this.renderChooseType()}
        {this.renderChooseReceivingLocation()}
        {this.renderAddItemTopBar()}
        {this.renderAddedItems()}
      </ControlGroup>
    );
  };

  render() {
    return (
      <div className="card__top__bottom__space">
        <Card elevation={Elevation.FOUR} className="unsaved__bg">
          {this.renderAll()}
          <br />
          {this.renderMetadataEntry()}
          <br />
          {this.renderSave()}
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(LedgerCreator));
